module.exports = __webpack_public_path__ + "img/Icone_512.430f1dd3.png";